<template>
    <div class='log_wrap'>
        <div class='steps'>
            <!-- 步骤条 -->
            <el-steps :active="+deployLogData.setups"  align-center>

                <el-step
                    v-for="(item, index) of setups"
                    :key='index'
                    :title="item">
                </el-step>

            </el-steps>
        </div>
        <div class='fileEdit'>
            <!-- <el-button type='primary'>配置文件编辑</el-button> -->
        </div>

        <div class='statusBg'>
            <div  class='statusBg_left'>

                <el-button  v-if='deployLogData.start_build' type='primary' @click='startBuild'>开始部署</el-button>//v-w-role="'cicdCxjcYysYyfb'"

                <el-button  v-if='deployLogData.end && deployLogData.next_one' type="primary" @click='deployNext'>部署下一台</el-button>//v-w-role="'cicdCxjcYysYyfbNext'"
                
                <el-button  v-if='!deployLogData.end' type='primary' @click='deployKillBtn'>终止</el-button>//v-w-role="'cicdCxjcYysYyzz'"
                
                <el-button v-if='params.envId===4'  type='primary' @click='rollBack'>回滚</el-button>//v-w-role="'cicdCxjcYysYyhg'"
                
            </div>
            <div class='statusBg_right'>
                <div>控制台代码风格选择</div>
                <div @click="changeStyle">
                    <img data-type='dark' src="../../../../assets/dark.png" alt="">
                    <img data-type='light' src="../../../../assets/light.png" alt="">
                    <img data-type='black' src="../../../../assets/black.png" alt="">
                </div>
            </div>
        </div>

        <div class='logStyle dark' ref='logStyle'>
            <div class='logList'>

                <li v-for='(item, index) of list' :key='index'>

                    <strong>{{item.display_time}}</strong>

                    &nbsp;&nbsp;

                    <span
                        :style= '{"color":`${ item.color!=="black" ? item.color : "" }`}'
                        v-if='!Array.isArray(item.message)'>
                        {{item.message}}

                    </span>

                    <span
                        :style= '{"color":`${ item.color!=="black" ? item.color : "" }`}'
                        v-if='Array.isArray(item.message)'>
                        <span v-if='item.message[0]'>{{item.message[0]}}</span>
                        
                        <a
                            v-if='item.message[1]'
                            :href="item.message[1]"
                            class="document-btn"
                            target="_blank">
                            {{item.message[1]}}
                        </a>
                        
                        <span v-if='item.message[2]'>{{item.message[2]}}</span>
                    </span>

                </li>
            </div>
            <div
             v-if='!deployLogData.end'
             v-loading="true"
             element-loading-spinner="el-icon-loading"
             class='logListLoading'>
            </div>
        </div>
    </div>
</template>

<script>
    import services from '../../cicd.services'
    export default {
        data() {
            return {
                show_form: {
                    app_tree: {}
                },
                deployLogData: {},
                list: [],
                timer: null,
                setups: ['输入检查', '环境检查', '代码检查', '生成tag', '打包代码', '部署'],
                pid: ''
            }
        },

        computed: {
            params() {
                return this.$route.params
            },
            selfId() {
                return this.params.selfId
            },
            userInfo() {
                return this.$store.state.userInfo
            }
        },

        watch: {
            selfId() {
                this.list = []
                this.deployLogData.setups = -1
                this.getlist()
            }
        },

        mounted() {
            this.getlist()
        },
        
        methods: {
            // 回滚
            rollBack() {
                this.$router.push({
                    name: "RollBack",
                    params: {
                        ...this.params,
                        pid: this.deployLogData.pid
                    }
                })
            },

            // 开始部署
            startBuild() {
                services.deployRun({deploy_id: this.selfId})
                    .then(res => this.$message.success('开始部署'))
                    .catch(err => this.$message.error(err.message))
            },

            // 终止
            deployKillBtn() {
                services.deployKill({pid: this.deployLogData.pid})
                    .then(res => this.$message.success('已终止'))
                    .catch(err => this.$message.error(err.message))
            },

            // 获取日志信息
            getlist(params) {
                this.chatlog()
                params = {
                    ...params,
                    deploy_id: this.$route.params.selfId
                }
                services.deployLog(params)
                    .then(res => {
                        this.deployLogData ={ ...res }
                        res.line.forEach(item => this.list.push(item))
                        this.chatlog()
                        clearTimeout(this.timer)
                        if (res.end){
                            this.timer = setTimeout(() => {
                                services.deployLog(params)
                                    .then(res => {
                                        this.deployLogData = {...res}
                                        res.line.forEach(item => this.list.push(item))
                                        clearTimeout(this.timer)
                                        this.chatlog()
                                    })
                            }, 10000)


                            return
                        }
                        if (this.deployLogData.stop_time) {
                            this.timer = setTimeout(() => {
                                this.getlist({ start_time: this.deployLogData.stop_time })
                            }, 2000)
                        }

                    })
                    .catch(err => this.$message.error(err.message))
            },

            chatlog() {
                this.$nextTick(() => {
                    this.$refs.logStyle.scrollTop = this.$refs.logStyle.scrollHeight;
                })
            },

            // 改变代码风格
            changeStyle(e) {
                let dataType = e.target.getAttribute("data-type")
                if (dataType) {
                    this.$refs.logStyle.className = 'logStyle ' + dataType
                }
            },

            // 部署下一台
            deployNext() {
                let params = {
                    deploy_Id: this.$route.params.selfId,
                    next_one: true,
                }
                services.deployRun(params)
                    .then(res => this.getlist({ start_time: this.deployLogData.stop_time }))
                    .catch(err => this.$message.error(err.massage))
            },

            // 获取部署单详情
            getDetil() {
                services.deployDescribe({ deploy_id: this.$route.query.ind })
                    .then(
                        res => {
                            let params = []
                            for (let item in res.app_tree.params) {
                                params.push({ key: item, value: res.app_tree.params[item] });
                            }
                            this.show_form = res && {
                                ...res,
                                app_tree: {
                                    ...res.app_tree,
                                    params
                                }
                            }
                        })
                    .catch(err => err && this.$message.error(err.message))
            }
        },

        destroyed() {
            clearTimeout(this.timer)
        }
    }
</script>

<style lang='scss' scoped>
    .log_wrap {
        width: 100%;
        height: 100%;
        // display:flex;
        // flex-direction: column;
        .steps {
            padding-bottom: 20px;
        }
        .fileEdit {
            margin: 20px 0;
        }
        .statusBg {
            margin: 40px 0;
            padding-right:10px;
            display:flex;
            align-items:center;
            justify-content: space-between;
            .statusBg_right {
                :nth-of-type(1) {
                    text-align: center;
                    margin-bottom: 20px;
                }
                &:nth-last-child(1) {
                    img {
                        width:80px;
                        height:80px;
                        margin: 0 10px;
                        cursor: pointer;
                    }
                }
            }
        }
        .logStyle {
            width: 100%;
            overflow: auto;
            height: 600px;
            flex:1;
        }
        .dark {
            background: #1e1e1e;
            color: #7bdcfe;
        }
        .light {
            background: #fffcf1;
            color: #999;
        }
        .black {
            background: #000;
            color: #fff;
        }
        .logListLoading {
            width: 20px;
            height: 20px;
            margin-top: 10px;
            background: transparent;
            font-size: 20px;
        }
    }
</style>
